<template>
  <v-layout style="flex-direction:column">    
    <v-tabs class="mx-2 mt-2 sub-menu" style="flex:0 0 auto;"      
      slider-color="primary">                  
      <h2 class="pa-2">{{glider.GLI_KEY}} : </h2>   
      <v-tab exact ripple :to="{name:'EditGlider'}">      
        Fiche Glider
      </v-tab>  
      <v-tab exact ripple :to="{name:'FormGlider'}">
        Infos générales
      </v-tab>      
      <v-tab ripple :to="{name:'DocumentsGlider'}">
        Documents
      </v-tab>      
      <v-tab ripple :to="{name:'MobilUnitsGlider'}">
        Mobil Unit
      </v-tab>   
    </v-tabs>    
    <router-view class="mt-0" />
    
  </v-layout>
</template>

<script lang="ts">
  import Vue from 'vue'
  import Component from 'vue-class-component'


  @Component({
    name: 'AdminGliderMenu'
  })
  export default class AdminGliderMenu extends Vue {  
    get glider() {
      return this.$store.myGetters.originalAdmGlider
    }
  }
</script>

<style scope>

  .sub-menu .v-tabs__item--active{
    background-color:transparent;
  } 

</style>
